module.exports = __webpack_public_path__ + "img/pharmacies.9473459.svg";